import { createReducer } from 'redux-create-reducer'
import type { TrackId } from 'types/track'
import {
  FORM_TRACK_MERGE_CONFIRM,
  FORM_TRACK_MERGE_RESET,
  FORM_TRACK_MERGE_SELECT_ORIGINAL_FORMAT,
  TRACK_MERGE,
  TRACK_MERGE_ERROR,
  TRACK_MERGE_SUCCESS,
} from '@disco/constants/ActionTypes'
export type State = {
  mergeStatus: 'merging' | 'error' | null
  mergeConfirmed: boolean
  originalFormatTrackId: TrackId | null | undefined
}
const initialState: State = {
  mergeStatus: null,
  mergeConfirmed: false,
  originalFormatTrackId: null,
}
export const trackMergeReducer = createReducer<State, any>(initialState, {
  [FORM_TRACK_MERGE_RESET]() {
    return initialState
  },

  [FORM_TRACK_MERGE_SELECT_ORIGINAL_FORMAT](state, { originalFormatTrackId }) {
    return { ...state, originalFormatTrackId }
  },

  [FORM_TRACK_MERGE_CONFIRM](state) {
    return { ...state, mergeConfirmed: true }
  },

  [TRACK_MERGE](state) {
    return { ...state, mergeStatus: 'merging' }
  },

  [TRACK_MERGE_SUCCESS]() {
    return initialState
  },

  [TRACK_MERGE_ERROR](state) {
    return { ...state, mergeStatus: 'error' }
  },
})
